// ============================================================
// CENTRALIZED COLOR TOKENS
// src/constants/colorTokens.js
// ============================================================
//
// Single source of truth for color values in JavaScript.
//
// The `colorTokens` object below is auto-generated from:
//   src/assets/scss/_variables.scss  ($theme-color-palette map)
//
// HOW TO KEEP IN SYNC WITH SCSS:
//   After adding/editing colors in _variables.scss, run:
//     npm run generate:colors
//   This regenerates the <auto-generated> block below.
//
// FOR CSS/SCSS: use CSS custom properties (var(--color-*)) or SCSS vars.
// FOR JS (inline styles, charts, PDF, Stripe, SVG props):
//   import { colorTokens, primary, CHART_COLORS, ... } from "constants/colorTokens"
// ============================================================

// <auto-generated from _variables.scss — run `npm run generate:colors` to update>
// Source: src/assets/scss/_variables.scss → $theme-color-palette
// Last generated: 2026-07-14T08:16:19.173Z
export const colorTokens = {
  // --- Brand · Ruby (primary) ---
  primary: "#ff0d5e",
  "primary-light": "#fcbecf",
  "primary-lighter": "#fcbecf",
  "primary-lightest": "#ffe7ef",
  "primary-dark": "#cc0a4b",
  "primary-darker": "#990838",
  "primary-darkest": "#660526",

  // --- Brand · Amethyst (secondary) ---
  secondary: "#7a29a8",
  "secondary-light": "#e6baff",
  "secondary-lighter": "#f5e2ff",
  "secondary-lightest": "#f7e8ff",
  "secondary-dark": "#622186",
  "secondary-darker": "#5c1f7e",
  "secondary-darkest": "#2b0e3b",

  // --- Status · Warning ---
  "warning-primary": "#ffc600",
  "warning-light": "#ffedb0",
  "warning-dark": "#cc9e00",

  // --- Status · Danger ---
  "danger-primary": "#ff2900",
  "danger-light": "#ffbdb0",
  "danger-dark": "#cc2100",

  // --- Status · Success ---
  "success-primary": "#38b95d",
  "success-light": "#bfddc8",
  "success-dark": "#30914c",

  // --- Status · Info ---
  "info-primary": "#356de4",
  "info-light": "#c0d2f7",
  "info-dark": "#2a57b6",

  // --- Neutral · Base ---
  "basic-white": "#ffffff",
  "bg-page": "#f9fafb",
  black: "#000000",

  // --- Neutral · Grey ---
  "neutral-grey-primary": "#64748b",
  "neutral-grey-light": "#cbd5e1",
  "neutral-grey-lighter": "#f1f5f9",
  "neutral-grey-lightest": "#f8fafc",
  "neutral-grey-dark": "#334155",
  "neutral-grey-darker": "#0f172a",
  "neutral-grey-darkest": "#020617",

  // --- Neutral · Rose ---
  "neutral-rose-primary": "#e362b4",
  "neutral-rose-light": "#f6cee8",
  "neutral-rose-lighter": "#fbe7f4",
  "neutral-rose-lightest": "#fceff8",
  "neutral-rose-dark": "#b64e90",
  "neutral-rose-darker": "#aa4a87",
  "neutral-rose-darkest": "#4f223f",

  // --- Neutral · Teal ---
  "neutral-teal-primary": "#049f9a",
  "neutral-teal-light": "#b1e1e0",
  "neutral-teal-lighter": "#d9f1f0",
  "neutral-teal-lightest": "#e6f5f5",
  "neutral-teal-dark": "#037f7b",
  "neutral-teal-darker": "#037774",
  "neutral-teal-darkest": "#4b4d22",

  // --- Neutral · Mint Green ---
  "neutral-mintgreen-primary": "#d7db61",
  "neutral-mintgreen-light": "#f3f4ce",
  "neutral-mintgreen-lighter": "#f9fae7",
  "neutral-mintgreen-lightest": "#fbfbef",
  "neutral-mintgreen-dark": "#acaf4e",
  "neutral-mintgreen-darker": "#a1a449",
  "neutral-mintgreen-darkest": "#143b36",

  // --- Secondary · Fuchsia ---
  "secondary-fuchsia-primary": "#d40e8c",
  "secondary-fuchsia-light": "#f2b4db",
  "secondary-fuchsia-lighter": "#f9dbee",
  "secondary-fuchsia-lightest": "#fbe7f4",
  "secondary-fuchsia-dark": "#aa0b70",
  "secondary-fuchsia-darker": "#9f0b69",
  "secondary-fuchsia-darkest": "#4a0531",

  // --- Secondary · Gold ---
  "secondary-gold-primary": "#ffc600",
  "secondary-gold-light": "#ffedb0",
  "secondary-gold-lighter": "#fff6d9",
  "secondary-gold-lightest": "#fff9e6",
  "secondary-gold-dark": "#cc9e00",
  "secondary-gold-darker": "#bf9500",
  "secondary-gold-darkest": "#594500",

  // --- Secondary · Charcoal ---
  "secondary-charcoal-primary": "#2f0b1b",
  "secondary-charcoal-light": "#bfb3b8",
  "secondary-charcoal-lighter": "#e0dadd",
  "secondary-charcoal-lightest": "#eae7e8",
  "secondary-charcoal-dark": "#260916",
  "secondary-charcoal-darker": "#230814",
  "secondary-charcoal-darkest": "#100409",

  // --- Tertiary · Ice Cool ---
  "tertiary-ice-cool-primary": "#f7f7ff",
  "tertiary-ice-cool-light": "#c0d2f7",
  "tertiary-ice-cool-lighter": "#fefeff",
  "tertiary-ice-cool-lightest": "#fefeff",
  "tertiary-ice-cool-dark": "#c6c6cc",
  "tertiary-ice-cool-darker": "#b9b9bf",
  "tertiary-ice-cool-darkest": "#565659",

  // --- Tertiary · Sapphire ---
  "tertiary-sapphire-primary": "#356de4",
  "tertiary-sapphire-light": "#7ea0f9",
  "tertiary-sapphire-lighter": "#e1e9fb",
  "tertiary-sapphire-lightest": "#ebf0fc",
  "tertiary-sapphire-dark": "#2a57b6",
  "tertiary-sapphire-darker": "#2852ab",
  "tertiary-sapphire-darkest": "#132650",

  // --- Tertiary · Green ---
  "tertiary-green-primary": "#38b95d",
  "tertiary-green-light": "#bfddc8",
  "tertiary-green-lighter": "#e0efe4",
  "tertiary-green-lightest": "#eaf4ed",
  "tertiary-green-dark": "#30914c",
  "tertiary-green-darker": "#246d39",
  "tertiary-green-darkest": "#11331b",

  // --- Tertiary · Orange ---
  "tertiary-orange-primary": "#ff2900",
  "tertiary-orange-light": "#ffbdb0",
  "tertiary-orange-lighter": "#ffdfd9",
  "tertiary-orange-lightest": "#ffeae6",
  "tertiary-orange-dark": "#cc2100",
  "tertiary-orange-darker": "#bf1f00",
  "tertiary-orange-darkest": "#590e00",

  // --- Typography ---
  "body-default": "#2a323a",
  "body-light": "#bdbfc2",
  "body-lighter": "#dfe0e1",
  "body-lightest": "#eaebeb",
  "body-dark": "#22282e",
  "body-darker": "#20262c",
  "body-darkest": "#0f1214",

  // --- Shadows & Overlays ---
  "shadow-xs": "rgba(0, 0, 0, 0.05)",
  "shadow-sm": "rgba(0, 0, 0, 0.08)",
  "shadow-md": "rgba(0, 0, 0, 0.12)",
  "shadow-lg": "rgba(0, 0, 0, 0.15)",
  "shadow-xl": "rgba(0, 0, 0, 0.2)",
  "shadow-2xl": "rgba(0, 0, 0, 0.3)",
  "shadow-heavy": "rgba(0, 0, 0, 0.5)",
  "shadow-dark": "rgba(0, 0, 0, 0.35)",
  "table-shadow": "rgba(100, 121, 143, 0.122)",
  "material-shadow-sm": "rgba(60, 64, 67, 0.15)",
  "material-shadow-md": "rgba(60, 64, 67, 0.3)",
  "overlay-dark-light": "rgba(0, 0, 0, 0.1)",
  "success-bg-alpha": "rgba(56, 185, 93, 0.15)",

  // --- Brand · Ruby (primary) ---
  "primary-gradient-from": "rgba(183, 22, 134, 1)",
  "primary-gradient-to": "rgba(216, 21, 96, 1)",
  "primary-btn-text": "#ffffff",

  // --- Shadows & Overlays ---
  "overlay-white-light": "rgba(255, 255, 255, 0.1)",
  "overlay-white-medium": "rgba(255, 255, 255, 0.5)",
  "overlay-white-heavy": "rgba(255, 255, 255, 0.8)",
  "overlay-white-full": "rgba(255, 255, 255, 1)",

  // --- Other ---
  "charts-series-1": "#5c1f7e",
  "charts-series-2": "#e6baff",
  "charts-series-3": "#7a29a8",
  "charts-series-4": "#f5e2ff",
  "charts-series-5": "#b859ed",
  "charts-series-6": "#7107dc",
  "charts-series-7": "#c6b4f2",
  "charts-series-8": "#8a29a8",
  "charts-series-9": "#6355c7",
  "charts-series-10": "#00aee0",
  "charts-series-11": "#356de4",
  "charts-series-12": "#82c100",
  "charts-series-13": "#05bb3d",
  "charts-series-14": "#274090",
  "charts-series-15": "#03b4b4",
  "charts-series-16": "#132650",
  "charts-series-17": "#ffc600",
  "charts-series-18": "#d40e8c",
  "charts-series-19": "#ed540c",
  "charts-series-20": "#ff0d5e",
  "charts-series-21": "#246d39",
  "status-paid": "#38b95d",
  "status-unpaid": "#f9a825",
  "status-current": "#356de4",
  "status-overdue": "#ff2900",
  "status-billed": "#6355c7",
  "status-partially-received": "#049f9a",
  "status-fulfillment": "#f9a825",
  "status-fulfilled": "#049f9a",
  "status-pending": "#f9a825",
  "status-open": "#64748b",
  "severity-critical": "#c62828",
  "severity-very-high": "#ff2900",
  "severity-high": "#f4511e",
  "severity-moderate-high": "#ef6c00",
  "severity-medium": "#f9a825",
  "severity-moderate-low": "#274090",
  "severity-low": "#356de4",
  "severity-very-low": "#00aee0",
  "severity-none": "#64748b",
};
// </auto-generated>

// ============================================================
// HELPERS
// ============================================================

/**
 * Read a CSS custom property from :root at runtime.
 * Use this for inline React styles that live in the DOM (CSS vars work there).
 *   getCSSVar("--color-primary")  →  "#ff0d5e"
 */
export function getCSSVar(name) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
}

/**
 * Look up a design-system token by its SCSS key name.
 *   getToken("primary-dark")  →  "#cc0a4b"
 */
export function getToken(key) {
  return colorTokens[key] ?? null;
}

// ============================================================
// SEMANTIC SHORTCUTS  (camelCase aliases for the most-used tokens)
// Add more here as needed; keep aligned with $theme-color-palette.
// ============================================================

// Brand
export const primary = colorTokens["primary"];
export const primaryLight = colorTokens["primary-light"];
export const primaryDark = colorTokens["primary-dark"];
export const primaryDarker = colorTokens["primary-darker"];
export const primaryLightest = colorTokens["primary-lightest"];

export const secondary = colorTokens["secondary"];
export const secondaryLight = colorTokens["secondary-light"];
export const secondaryDark = colorTokens["secondary-dark"];
export const secondaryLightest = colorTokens["secondary-lightest"];

// Status
export const successPrimary = colorTokens["success-primary"];
export const successLight = colorTokens["success-light"];
export const successDark = colorTokens["success-dark"];

export const warningPrimary = colorTokens["warning-primary"];
export const warningLight = colorTokens["warning-light"];
export const warningDark = colorTokens["warning-dark"];

export const dangerPrimary = colorTokens["danger-primary"];
export const dangerLight = colorTokens["danger-light"];
export const dangerDark = colorTokens["danger-dark"];

export const infoPrimary = colorTokens["info-primary"];
export const infoLight = colorTokens["info-light"];
export const infoDark = colorTokens["info-dark"];

// Neutral
export const white = colorTokens["basic-white"];
export const black = colorTokens["black"];
export const bgPage = colorTokens["bg-page"];

export const neutralGrey = colorTokens["neutral-grey-primary"];
export const neutralGreyLight = colorTokens["neutral-grey-light"];
export const neutralGreyDark = colorTokens["neutral-grey-dark"];

// Typography
export const bodyDefault = colorTokens["body-default"];
export const bodyLight = colorTokens["body-light"];
export const bodyDark = colorTokens["body-dark"];

// ============================================================
// CHART & DATA-VIZ PALETTES
// All sourced from colorTokens — design-system aligned.
// ============================================================

/**
 * Primary 12-color chart palette.
 * Covers bar/line/pie charts and data-series with many buckets.
 * Entirely derived from $theme-color-palette in _variables.scss.
 */
export const CHART_COLORS = [
  colorTokens["tertiary-sapphire-primary"],
  colorTokens["success-primary"],
  colorTokens["warning-primary"],
  colorTokens["danger-primary"],
  colorTokens["severity-none"],
  colorTokens["charts-series-18"],
  colorTokens["charts-series-19"],
  colorTokens["charts-series-20"],
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-11"],
  colorTokens["charts-series-12"],
];

export const RISK_COLORS = [
  colorTokens["status-critical"], // Critical  #ff2900
  colorTokens["status-high"], // High      (no exact SCSS token)
  colorTokens["status-medium"], // Medium    #ffc600
  colorTokens["status-low"], // Low       #d7db61
  colorTokens["status-open"], // None      (no SCSS token)
];

/**
 * Dispute status colors — keyed by status string.
 */
export const DISPUTE_STATUS_COLORS = {
  OPEN: colorTokens["status-open"], // gold
  IN_PROGRESS: CHART_COLORS[0], // sapphire blue
  IN_REVIEW: CHART_COLORS[1], // green
  PENDING_APPROVAL: CHART_COLORS[7], // rose
  RESOLVED: CHART_COLORS[5], // mint
  CLOSED: colorTokens["neutral-grey-primary"],
  ESCALATED: CHART_COLORS[3], // red
};

/**
 * Dispute priority colors — keyed by priority string.
 */
export const DISPUTE_PRIORITY_COLORS = {
  LOW: colorTokens["status-low"],
  MEDIUM: colorTokens["status-medium"],
  HIGH: colorTokens["status-high"],
  CRITICAL: colorTokens["status-critical"],
};

/**
 * Industry Insights extended palette.
 */
export const INDUSTRY_COLORS = [
  colorTokens["info-primary"], // #356de4 – info blue (replaces #3fa2cc)
  CHART_COLORS[3], // red
  CHART_COLORS[1], // green
  CHART_COLORS[2], // gold
  colorTokens["neutral-grey-primary"], // grey
  CHART_COLORS[5], // mint
  colorTokens["chart-series-21"], // dark green
  colorTokens["neutral-rose-primary"], // rose
  "#9b0707", // deep red  (no SCSS token)
  "#08067a", // deep navy (no SCSS token)
  "#6d0e6c", // deep purple (no SCSS token)
  "#897711", // dark gold (no SCSS token)
];

// ============================================================
// CONTEXT-SPECIFIC CONSTANTS
// These cannot use CSS custom properties (third-party SDKs).
// ============================================================

/**
 * Stripe Elements inline style.
 * Stripe.js requires plain hex/rgba strings — CSS vars are not supported.
 */
export const STRIPE_STYLE = {
  base: {
    color: colorTokens["body-default"], // #2a323a
    fontFamily: '"mosk-medium", sans-serif',
    fontSmoothing: "antialiased",
    "::placeholder": {
      color: colorTokens["neutral-grey-light"], // #cbd5e1
    },
  },
  invalid: {
    color: colorTokens["danger-primary"], // #ff2900
  },
};

/**
 * PDF table header fill color (jsPDF autoTable headStyles.fillColor).
 */
export const PDF_TABLE_HEADER_COLOR = colorTokens["neutral-grey-light"]; // #cbd5e1
export const PDF_TABLE_HEADER_ALT = "#bdc0bf";

/**
 * Window-loader gradient colors (used in windowUtils.js HTML string).
 */
export const WINDOW_LOADER_BG_FROM = colorTokens["tertiary-sapphire-primary"]; // #356de4
export const WINDOW_LOADER_BG_TO = colorTokens["tertiary-sapphire-darker"]; // #2852ab
